export default {
      id: "teacher-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#teacher",
      toString: function () {
        return this.url;
      }
    }